module.exports = __webpack_public_path__ + "static/img/ct.79ce412.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer1/th/ct.png
// module id = Wgrh
// module chunks = 1